import { Counter, MyleCounterStyle } from "./Counters";
import { ICounters } from "./ICounters";

/**
 * Represents a set of Prescription Renewals counters.
 * Implements the ICounters interface to track unread Prescription Renewals.
 */
class PrescriptionRenewalsCounters implements ICounters {
    /** The amount of new presciptions renewals unread. */
    private readonly newPrescriptionRenewalsCount: number;

    /** The amount of urgent new prescipcion renewals unread. */
    private readonly urgentNewPrescriptionRenewalsCount: number;

    /** The amount of pending presciption renewals unread. */
    private readonly pendingPrescriptionRenewalsCount: number;

    /** The amount of urgent pending presciption renewals unread. */
    private readonly urgentPendingPrescriptionRenewalsCount: number;

    /**
     * Creates an instance of PrescriptionRenewalsCounters.
     * @param {number} newPrescriptionRenewalsCount - The amount of new prescriptions renewals unread.
     * @param {number} urgentNewPrescriptionRenewalsCount - The amount of urgent new prescriptions renewals unread.
     * @param {number} pendingPrescriptionRenewalsCount - The amount of pending prescriptions renewals unread.
     * @param {number} urgentPendingPrescriptionRenewalsCount - The amount of urgent pending prescriptions renewals unread.
    */
    constructor(
        newPrescriptionRenewalsCount: number,
        urgentNewPrescriptionRenewalsCount: number,
        pendingPrescriptionRenewalsCount: number,
        urgentPendingPrescriptionRenewalsCount: number
    ) {
        this.newPrescriptionRenewalsCount = newPrescriptionRenewalsCount;
        this.urgentNewPrescriptionRenewalsCount = urgentNewPrescriptionRenewalsCount;
        this.pendingPrescriptionRenewalsCount = pendingPrescriptionRenewalsCount;
        this.urgentPendingPrescriptionRenewalsCount = urgentPendingPrescriptionRenewalsCount;
    }

    /**
     * Retrieves an array of Counter objects representing each type of Prescription Renewals counter.
     * @returns {Counter[]} An array of counters with their respective value, label and style.
     */
    public getCounters(): Counter[] {
        return [
            new Counter(this.newPrescriptionRenewalsCount, "Tooltip_NewsRx", MyleCounterStyle.blueCircleWithBackground),
            new Counter(this.urgentNewPrescriptionRenewalsCount, "Tooltip_NewAndUrgentRx", MyleCounterStyle.redCircleWithBackground),
            new Counter(this.pendingPrescriptionRenewalsCount, "Tooltip_PendingRx", MyleCounterStyle.blueCircleNoBackground),
            new Counter(this.urgentPendingPrescriptionRenewalsCount, "Tooltip_PendingAndUrgentRx", MyleCounterStyle.redCircleNoBackground)
        ];
    }

    /**
     * Determines if the counter can be displayed.
     * @returns {boolean} True if the counter can be displayed, otherwise false.
     */
    public showCounters(): boolean {
        return this.newPrescriptionRenewalsCount !== 0
            || this.urgentNewPrescriptionRenewalsCount !== 0
            || this.pendingPrescriptionRenewalsCount !== 0
            || this.urgentPendingPrescriptionRenewalsCount !== 0;
    }
}

export { PrescriptionRenewalsCounters };
